import { createReducer, createAction } from '@reduxjs/toolkit';
import { soluterProject } from '~/constants';

const INITIAL_STATE = {
  soluterProject: [],
  person: {},
  total: 0,
  soluter: {
    competences: [],
    districts: [],
    projects: [],
    towers: [],
    interviews: [],
  },
  week: { start: '', end: '' },
  page: 1,
  search: false,
  searchTitle: '',
  selectedCostCenter: [],
  selectedPractice: '',
  advancedSearch: {
    skills: [],
    seniorities: [],
    skillsOperator: 'or',
    leader: '',
    highPotential: '',
    onlyDismissed: false,
    competence: '',
    haveCompetence: false,
  },
  csvData: null,
};

export const get = createAction('soluterProject_GET');
export const search = createAction('soluterProject_SEARCH');
export const getSoluter = createAction('GET_SOLUTER');
export const clearSoluter = createAction('CLEAR_SOLUTER');
export const updateSoluterPhoto = createAction('UPDATE_SOLUTER_PHOTO');
export const setWeekInterval = createAction('soluterProject_SET_INTERVAL');
export const setSelectedPractice = createAction(
  'soluterProject_SET_SELECTED_PRACTICE',
);
export const setSolutersCostCenters = createAction(
  'soluterProject_SET_SOLUTERS_COST_CENTERS',
);
export const setSingleSoluterCostCenter = createAction(
  'soluterProject_SET_SOLUTER_COST_CENTERS',
);
export const setSoluterCompetences = createAction(
  'soluterProject_SET_SOLUTER_COMPETENCES',
);
export const setSoluterDistricts = createAction(
  'soluterProject_SET_SOLUTER_DISTRICTS',
);
export const setSoluterProjects = createAction(
  'soluterProject_SET_SOLUTER_PROJECTS',
);
export const setSoluterTowers = createAction(
  'soluterProject_SET_SOLUTER_TOWERS',
);
export const updateSoluterDistrictThumb = createAction(
  'soluterProject_UPDATE_SOLUTER_DISTRICT_THUMB',
);
export const updateSoluterTowerPhoto = createAction(
  'soluterProject_UPDATE_SOLUTER_TOWER_PHOTO',
);
export const setSelectedCostCenter = createAction(
  'soluterProject_SET_SELECTED_COST_CENTER',
);
export const removeSelectedCostCenter = createAction(
  'soluterProject_REMOVE_SELECTED_COST_CENTER',
);
export const setAdvancedSearchFilters = createAction(
  'soluterProject_SET_ADVANCED_SEARCH',
);
export const clearAdvancedSearchFilters = createAction(
  'soluterProject_CLEAR_ADVANCED_SEARCH',
);
export const removeAdvancedSearchFilter = createAction(
  'soluterProject_REMOVE_ADVANCED_SEARCH_FILTER',
);
export const getCsvData = createAction('soluterProject_GET_CSV_DATA');
export const getExitInterviews = createAction(
  'soluterProject_GET_SOLUTER_INTERVIEWS',
);
export const clearCsvData = createAction('soluterProject_CLEAR_CSV_DATA');
export const getSoluterProjects = createAction('soluterProject_GET_PROJECTS');

export default createReducer(INITIAL_STATE, {
  [get.type]: (state, action) => ({
    ...state,
    soluterProject: action.payload.content,
    total: action.payload.total,
    page: action.payload.page ? action.payload.page : state.page,
  }),
  [search.type]: (state, action) => ({
    ...state,
    search: action.payload.search,
    searchTitle: action.payload.searchTitle,
  }),
  [getSoluter.type]: (state, action) => ({
    ...state,
    soluter: { ...state.soluter, ...action.payload },
  }),
  [clearSoluter.type]: (state, action) => ({
    ...state,
    soluter: {
      competences: [],
      districts: [],
      projects: [],
      towers: [],
      interviews: [],
    },
    week: { start: '', end: '' },
  }),
  [updateSoluterPhoto.type]: (state, action) => ({
    ...state,
    soluterProject: state?.soluterProject?.map(person =>
      person.email === action.payload.email
        ? { ...person, thumb: action.payload.thumb }
        : person,
    ),
  }),
  [setWeekInterval.type]: (state, action) => ({
    ...state,
    week: action.payload,
  }),
  [setSelectedCostCenter.type]: (state, action) => ({
    ...state,
    selectedCostCenter: action.payload,
  }),
  [setAdvancedSearchFilters.type]: (state, action) => ({
    ...state,
    advancedSearch: {
      ...state.advancedSearch,
      skills: action.payload?.skills ?? [...state.advancedSearch.skills],
      seniorities: action.payload?.seniorities ?? [
        ...state.advancedSearch.seniorities,
      ],
      skillsOperator:
        action.payload?.skillsOperator ?? state.advancedSearch.skillsOperator,
      leader: action.payload?.leader,
      highPotential: action.payload?.highPotential,
      onlyDismissed: action.payload?.onlyDismissed,
      competence: action.payload?.competence,
      haveCompetence: action.payload?.haveCompetence,
    },
  }),
  [clearAdvancedSearchFilters.type]: (state, action) => ({
    ...state,
    advancedSearch: {
      skills: [],
      seniorities: [],
      skillsOperator: 'or',
      leader: '',
      highPotential: '',
      onlyDismissed: false,
      competence: '',
      haveCompetence: false,
    },
  }),
  [removeAdvancedSearchFilter.type]: (state, action) => ({
    ...state,
    advancedSearch: {
      ...state.advancedSearch,
      skills: state.advancedSearch.skills?.filter(el => el !== action.payload),
      haveCompetence:
        action.payload ===
        soluterProject.mapCompetenceFilterModes.ONLY_WITH_COMPETENCES
          ? false
          : state.advancedSearch.haveCompetence,
      competence:
        action.payload === state.advancedSearch.competence
          ? ''
          : state.advancedSearch.competence,
      seniorities: state.advancedSearch.seniorities?.filter(
        el => el !== action.payload,
      ),
      leader:
        action.payload === soluterProject.categories.LEADER
          ? ''
          : state.advancedSearch.leader,
      highPotential:
        action.payload === soluterProject.categories.HIGH_POTENTIAL
          ? ''
          : state.advancedSearch.highPotential,
      onlyDismissed:
        action.payload === soluterProject.categories.DISMISSED
          ? false
          : state.advancedSearch.onlyDismissed,
    },
  }),
  [setSelectedPractice.type]: (state, action) => ({
    ...state,
    selectedPractice: action.payload,
  }),
  [removeSelectedCostCenter.type]: (state, action) => ({
    ...state,
    selectedCostCenter: state.selectedCostCenter.filter(
      el => el !== action.payload,
    ),
  }),
  [setSolutersCostCenters.type]: (state, action) => ({
    ...state,
    soluterProject: state?.soluterProject?.map(person => {
      const userCostCenter = action.payload.filter(
        costCenters => costCenters.id === person.email,
      )[0];

      return userCostCenter
        ? {
            ...person,
            costCenter: userCostCenter.costCenter,
            costCenterId: userCostCenter.costCenterId,
          }
        : person;
    }),
  }),
  [setSingleSoluterCostCenter.type]: (state, action) => ({
    ...state,
    soluter: {
      ...state.soluter,
      costCenter: action.payload[0].costCenter,
      costCenterId: action.payload[0].costCenterId,
    },
  }),
  [setSoluterCompetences.type]: (state, action) => ({
    ...state,
    soluter: {
      ...state.soluter,
      competences: action.payload,
    },
  }),
  [setSoluterDistricts.type]: (state, action) => ({
    ...state,
    soluter: {
      ...state.soluter,
      districts: action.payload,
    },
  }),
  [updateSoluterDistrictThumb.type]: (state, action) => ({
    ...state,
    soluter: {
      ...state.soluter,
      districts: state.soluter?.districts?.map(district =>
        district.id === action.payload.id
          ? { ...district, thumb: action.payload.thumb }
          : district,
      ),
    },
  }),
  [setSoluterProjects.type]: (state, action) => ({
    ...state,
    soluter: {
      ...state.soluter,
      projects: action.payload,
    },
  }),
  [updateSoluterTowerPhoto.type]: (state, action) => ({
    ...state,
    soluter: {
      ...state.soluter,
      towers: state.soluter?.towers?.map(tower =>
        tower.id === action.payload.id
          ? { ...tower, thumb: action.payload.thumb }
          : tower,
      ),
    },
  }),
  [setSoluterTowers.type]: (state, action) => ({
    ...state,
    soluter: {
      ...state.soluter,
      towers: action.payload,
    },
  }),
  [getCsvData.type]: (state, action) => ({
    ...state,
    csvData: action.payload,
  }),
  [clearCsvData.type]: (state, action) => ({
    ...state,
    csvData: null,
  }),
  [getExitInterviews.type]: (state, action) => ({
    ...state,
    soluter: { ...state.soluter, interviews: action.payload },
  }),
  [getSoluterProjects.type]: (state, action) => ({
    ...state,
    projects: action.payload,
  }),
});
